import { useEffect, useState } from "react";
import PickUpServices from "../../../Services/PickUpService";
import { Col, Row } from "react-bootstrap-v5";

export const ViewPickUp = () => {
  const [isDataLoaded, setIsDataLoaded] = useState(false);
  const [data, setData] = useState({});
  const search = window.location.search;
  const params = new URLSearchParams(search);
  const pickUpId = params.get("id");

  useEffect(() => {
    PickUpServices.getPickUpDetails({ pickup_id: pickUpId }).then((result) => {
      if (result.status === true) {
        setData(result.data);
        setIsDataLoaded(true);
      }
    });
  }, [pickUpId]);


  const receipt = {
    RECEIVED: 'Received',
    NOT_RECEIVED: 'Not Received',
    PARTIAL_RECEIVED: 'Partial Received',
  }

  const status = {
    PENDING: 'Pending',
    ASSIGNED: 'Assigned',
    RECEIVED: 'Received',
  }

  const pickupDetails = [
    { label: "Name", value: data?.full_name },
    { label: "Job No", value: data?.job_token },
    { label: "Retailer Mobile No", value: data?.retailer_phone_number },
    {
      label: "Pickup Status",
      value: data?.pickup_status ? (
        <span className={
          data?.pickup_status === "PENDING" ? "text-warning fw-bold" :
            data?.pickup_status === "ASSIGNED" ? "text-primary fw-bold" :
              data?.pickup_status === "RECEIVED" ? "text-success fw-bold" :
                ""
        }>
          {status[data?.pickup_status]}
        </span>
      ) : "-"
    },
    { label: "Who Will Pick Up", value: data?.pickup_type },
    { label: "Transport By", value: data?.transport_by === "WORLDTODOOR" ? "W2D Transport" : "Transport Vendor" },
    ...(data?.transport_by === "VENDOR"
      ? [{ label: "Transport Vendor Name", value: data?.vendor_name }]
      : []),
    { label: "Location", value: data?.pickup_address },
    { label: "Location Delivery Warehouse", value: data?.ware_house_name },
    { label: "Pickup Date", value: data?.pickup_date },
  ];

  const pickupDetails2 = [
    { label: "Pickup Time", value: data?.pickup_time },
    { label: "Postal Code", value: data?.pickup_postal_code },
    { label: "Receipt/Invoice Ref#", value: data?.invoice_id },
    { label: "Pickup Country", value: data?.pickup_country },
    { label: "Pickup State", value: data?.pickup_state },
    { label: "Pickup City", value: data?.pickup_city },
    { label: "Seller Order Id", value: data?.seller_order_id },
    {
      label: "Shipment Receipt Assorment",
      value: data?.shpt_receipt_assorment ? (
        <span className={
          data?.shpt_receipt_assorment === "RECEIVED" ? "text-success fw-bold" :
            data?.shpt_receipt_assorment === "PARTIAL_RECEIVED" ? "text-warning fw-bold" :
              "text-danger fw-bold"
        }>
          {receipt[data?.shpt_receipt_assorment]}
        </span>
      ) : "-"
    },
    ...(data?.courier_partner
      ? [
        { label: "Courier Partner", value: data?.courier_partner },
        { label: "Courier Partner's AWB Number", value: data?.cp_awb_number || "-" }
      ]
      : []),
    { label: "Comments", value: data?.comment },
  ];

  const totals = data?.item_detail?.reduce(
    (acc, item) => {
      const actual = item.actual || {};
      acc.no_of_pkgs += actual.no_of_pkgs || 0;
      acc.kilogram += actual.kilogram || 0;
      acc.length += actual.length || 0;
      acc.width += actual.width || 0;
      acc.height += actual.height || 0;
      acc.total_volume_CBM += actual.total_volume_CBM || 0;
      acc.total_weight_KG += actual.total_weight_KG || 0;
      return acc;
    },
    {
      no_of_pkgs: 0,
      kilogram: 0,
      length: 0,
      width: 0,
      height: 0,
      total_volume_CBM: 0,
      total_weight_KG: 0,
    }
  );

  if (!isDataLoaded) return <p className="text-center mt-4">Loading...</p>;

  return (
    <>
      <div className="container-fluid">
        <div className="white_box h-100">
          <Row>
            <Col md={6}>
              <div className="card p-3 mb-3">
                {/* <h5 className="secHeading mb-3">Pickup Details</h5> */}
                <table width="100%">
                  <tbody>
                    {pickupDetails.map((item, idx) => (
                      <tr key={idx}>
                        <td className="py-1" style={{ fontWeight: 600 }}>{item.label} - </td>
                        <td className="py-1">{item.value || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
            <Col md={6}>
              <div className="card p-3 mb-3">
                {/* <h5 className="secHeading mb-3">&nbsp;</h5> */}
                <table width="100%">
                  <tbody>
                    {pickupDetails2.map((item, idx) => (
                      <tr key={idx}>
                        <td className="py-1" style={{ fontWeight: 600 }}>{item.label} - </td>
                        <td className="py-1">{item.value || "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </Col>
          </Row>
        </div>
      </div>

      {/* Cargo Details Table stays same */}
      <div className="container-fluid">
        <div className="white_box h-100">
          <Row>
            <Col md={12} className="mb-4">
              <div className="card p-3">
                <div className="modal-body">
                  <Row>
                    <h5 className="mb-3 text-center">Cargo Details</h5>
                    <Col sm={12}>
                      <div className="table-responsive">
                        <table className="table table-bordered text-center volume-calcu">
                          <thead>
                            <tr className="lh-sm">
                              <th rowSpan="2" className="align-middle">S.no.</th>
                              <th rowSpan="2" className="align-middle">Item Description</th>
                              <th rowSpan="2" className="align-middle">No. of Pkgs/<br />Quantity</th>
                              <th colSpan="4">Weight & Dimension per Package</th>
                              <th rowSpan="2" className="align-middle">Total Volume<br />(CBM)</th>
                              <th rowSpan="2" className="align-middle">Total Weight<br />(KG)</th>
                            </tr>
                            <tr>
                              <th>Kilogram</th>
                              <th>Length</th>
                              <th>Width</th>
                              <th>Height</th>
                            </tr>
                          </thead>
                          <tbody>
                            {data?.item_detail?.map((item, index) => (
                              <tr key={index}>
                                <td>{index + 1}</td>
                                <td>{item.actual.item_description || "-"}</td>
                                <td>{item.actual.no_of_pkgs || 0}</td>
                                <td>{item.actual.kilogram || 0}</td>
                                <td>{item.actual.length || 0}</td>
                                <td>{item.actual.width || 0}</td>
                                <td>{item.actual.height || 0}</td>
                                <td>{item.actual.total_volume_CBM || 0}</td>
                                <td>{item.actual.total_weight_KG || 0}</td>
                              </tr>
                            ))}
                            {/* Total row */}
                            <tr className="fw-bold">
                              <td colSpan={2}>Total</td>
                              <td>{totals.no_of_pkgs}</td>
                              <td>{totals.kilogram}</td>
                              <td>{totals.length}</td>
                              <td>{totals.width}</td>
                              <td>{totals.height}</td>
                              <td>{totals.total_volume_CBM}</td>
                              <td>{totals.total_weight_KG}</td>
                            </tr>
                          </tbody>

                        </table>
                      </div>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};
